export enum ReconcileFlags {
  None = 0,
  SettlementJump = 1 << 0,
  MissedStop = 1 << 1,
  MissedFuel = 1 << 2,
  MissedDH = 1 << 3,
  DeltaMiles = 1 << 4,
  DeltaDH = 1 << 5,
  MilesEstimated = 1 << 6,
  BringingDriverHome = 1 << 7,
  SettlementMissing = 1 << 8,
  TeamPaidAsSolo = 1 << 9,
}

export const ReconcileFlagsMapping: Record<ReconcileFlags, string> = {
  [ReconcileFlags.None]: 'None',
  [ReconcileFlags.SettlementJump]: 'Settlement Jump',
  [ReconcileFlags.MissedStop]: 'Missed Stop',
  [ReconcileFlags.MissedFuel]: 'Missed Fuel',
  [ReconcileFlags.MissedDH]: 'Missed DH',
  [ReconcileFlags.DeltaMiles]: 'Miles Difference',
  [ReconcileFlags.DeltaDH]: 'DH Difference',
  [ReconcileFlags.MilesEstimated]: 'Miles Estimated',
  [ReconcileFlags.BringingDriverHome]: 'Bringing Driver Home',
  [ReconcileFlags.SettlementMissing]: 'Settlement Missing',
  [ReconcileFlags.TeamPaidAsSolo]: 'Team Paid As Solo',
};
